import { makeStyles, Theme } from '@material-ui/core/styles';

export const baseStyles = makeStyles((theme: Theme) => ({
    main: {
        margin: '0 auto',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',

        '& .htmlWrapper p': {
            fontSize: '1.25rem;',
            fontFamily: 'Interstate,Helvetica Neue,Helvetica,Arial,sans-serif',
            fontWeight: 300,
            lineHeight: '1.5rem'
        }
    },
    h1: {
        fontSize: '2.375rem',
        marginTop: 50,
        marginBottom: '1.25rem',
        fontWeight: 300,
        color: theme.palette.primary.light,
        lineHeight: '40px'
    },
    hr: {
        width: '100%',
        display: 'block',
        backgroundColor: `${theme.palette.primary.light}`,
        border: 'none',
        marginTop: 0,
        height: '2px',
        marginBottom: '20px'
    },
    spacingNormal: {
        marginBottom: '20px'
    },
    spacingMedium: {
        marginBottom: '25px'
    },
    spacingLarge: {
        marginBottom: '30px'
    },
    spacingLargeTop: {
        marginTop: '30px'
    },
    spacingExtraLarge: {
        marginBottom: '50px'
    },
    closeIcon: {
        textAlign: 'right',
        padding: 10
    },
    paragraph: {
        fontSize: '20px',
        fontWeight: 300,
        lineHeight: '24px',
        '& > div': {
            '& > h4': { fontWeight: 400 }
        }
    },
    smallPrint: {
        fontSize: 12,
        marginTop: '10px'
    },
    error: {
        color: '#A01E50'
    },
    buttonProgress: {
        color: theme.palette.common.white
    }
}));
